import type { RouteObject } from 'react-router';
import { InventoryPage } from './InventoryPage';
import { WarehouseStocksPage } from './WarehouseStocksPage';
import { InventoryChangesPage } from './InventoryChangesPage';
import { InTransitPage } from './InTransitPage';
import { TransactionsPage } from './TransactionsPage';
import { ShortagePage } from './ShortagePage';
import { PurchaseOrdersPage } from './PurchaseOrdersPage';
import { PurchaseOrderDetailPage } from './PurchaseOrderDetailPage';
import { PurchaseSuggestionsPage } from './PurchaseSuggestionsPage';

/** 库存与采购（只读期）。path 相对 /v2，挂在 AppShell 的 children 下 */
export const routes: RouteObject[] = [
  { path: 'inventory', element: <InventoryPage /> },
  { path: 'inventory/warehouses', element: <WarehouseStocksPage /> },
  { path: 'inventory/changes', element: <InventoryChangesPage /> },
  { path: 'inventory/transit', element: <InTransitPage /> },
  { path: 'inventory/transactions', element: <TransactionsPage /> },
  { path: 'inventory/shortage', element: <ShortagePage /> },
  { path: 'purchase-orders', element: <PurchaseOrdersPage /> },
  { path: 'purchase-orders/:id', element: <PurchaseOrderDetailPage /> },
  { path: 'purchase-suggestions', element: <PurchaseSuggestionsPage /> },
];
